import DaSteps from './DaSteps';
import GwatSteps from './GwatSteps';
import { useTenant } from 'lib/hooks/useTenant';

type Props = {
  stripeIsLoading: boolean;
};

const Steps = ({ stripeIsLoading }: Props) => {
  const { isDA, isGwat } = useTenant();

  return (
    <div className="bg-light-600 md:border border-light-800 rounded-md md:shadow-[0px_5px_5px_0px_#17181a0d] pt-0 md:pt-10">
      {isGwat ? <GwatSteps isLoading={stripeIsLoading} /> : null}
      {isDA ? <DaSteps isLoading={stripeIsLoading} /> : null}
    </div>
  );
};

export { Steps };
